export function Support() {
  return (
    <div className="legal-page">
      <main className="legal-content">
        <h1>Support</h1>
        <p className="legal-updated">Last updated: May 2026</p>

        <h2>Get in touch</h2>
        <p>Questions, feedback, or bug reports? We'd love to hear from you.</p>
        <p>
          Email us at <a href="mailto:hello@uhzlab.com">hello@uhzlab.com</a>. We typically respond within 1–3 business days.
        </p>

        <h2>Common questions</h2>
        <p><strong>How do I delete my account or designs?</strong><br />
          You can delete individual designs from <em>My Designs</em> at any time. To delete your account and all associated data, open <em>Settings &rarr; Delete Account</em> in the app. If you can&apos;t reach it, email us with the subject line &quot;Account deletion&quot;.
        </p>
        <p><strong>How do credits work?</strong><br />
          Creating or editing a design uses credits — the app shows your balance and what each action costs. Chatting with Gio is free. Signed-in users get free credits every day, plus bonus credits on sign-up and for each friend you invite. Bonus and purchased credits never expire. archelier Pro gives unlimited designs.
        </p>
        <p><strong>How do I buy more credits?</strong><br />
          Open <em>Settings &rarr; Buy credits</em> and choose a pack. In the iOS or Android app you pay through the App Store or Google Play; on archelier.co you can pay by card, Apple Pay or Google Pay.
        </p>
        <p><strong>I was charged but credits weren&apos;t added.</strong><br />
          Credits usually arrive within a minute. If they don&apos;t, email us with your receipt (the order ID from Apple or Google, or the email receipt for a web purchase) and we&apos;ll resolve it.
        </p>
        <p><strong>How do I get a refund?</strong><br />
          Purchases made in the app are refunded by Apple or Google — request one at reportaproblem.apple.com or from your Google Play order history. For purchases on archelier.co, email us. Refunded credits are removed from your balance.
        </p>

        <h2>Privacy &amp; Terms</h2>
        <p>
          See our <a href="/privacy">Privacy Policy</a> and <a href="/terms">Terms of Service</a> for details on how your data is handled and the agreement that governs your use of archelier.
        </p>
      </main>
    </div>
  );
}
